/* ---- Preloader: only show once per browser session, animate logo letters then fade ---- */
(function(){
  const preloader = document.getElementById('preloader');
  if(!preloader) return;

  const alreadySeen = sessionStorage.getItem('novara_preloaded');
  const logoEl = document.getElementById('pl-logo-text');
  const text = logoEl ? logoEl.getAttribute('data-text') || 'NOVARA' : 'NOVARA';

  if(alreadySeen){
    // Skip animation for returning-within-session visits, just remove instantly
    preloader.classList.add('hide');
    document.body.classList.remove('loading');
    return;
  }

  if(logoEl){
    logoEl.innerHTML = text.split('').map((ch,i)=>
      `<span style="animation-delay:${0.05*i}s">${ch === ' ' ? '&nbsp;' : ch}</span>`
    ).join('');
  }

  window.addEventListener('load', () => {
    setTimeout(() => {
      preloader.classList.add('hide');
      document.body.classList.remove('loading');
      sessionStorage.setItem('novara_preloaded', '1');
      setTimeout(revealCheck, 100);
    }, 1400);
  });
})();

/* ---- Stagger delays for any grid marked data-reveal-stagger ---- */
document.querySelectorAll('[data-reveal-stagger]').forEach(grid=>{
  [...grid.children].forEach((child,i)=>{
    child.style.transitionDelay = `${i*0.08}s`;
  });
});

/* ---- Scroll reveal via IntersectionObserver ---- */
const revealTargets = document.querySelectorAll('[data-reveal], [data-reveal-stagger]');
let observer;
if('IntersectionObserver' in window){
  observer = new IntersectionObserver((entries)=>{
    entries.forEach(entry=>{
      if(entry.isIntersecting){
        entry.target.classList.add('in-view');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  revealTargets.forEach(t => observer.observe(t));
} else {
  revealTargets.forEach(t => t.classList.add('in-view'));
}

function revealCheck(){
  revealTargets.forEach(t=>{
    const rect = t.getBoundingClientRect();
    if(rect.top < window.innerHeight * 0.9){
      t.classList.add('in-view');
    }
  });
}

/* ---- Live countdown for deal banner ---- */
document.querySelectorAll('[data-countdown]').forEach(box=>{
  const target = new Date(box.getAttribute('data-countdown')).getTime();
  const hEl = box.querySelector('[data-cd-hours]');
  const mEl = box.querySelector('[data-cd-mins]');
  const sEl = box.querySelector('[data-cd-secs]');
  if(!target || isNaN(target)) return;

  function tick(){
    const now = Date.now();
    let diff = target - now;
    if(diff <= 0){ diff = 0; }
    const hours = Math.floor(diff / 3600000);
    const mins = Math.floor((diff % 3600000) / 60000);
    const secs = Math.floor((diff % 60000) / 1000);
    if(hEl) hEl.textContent = String(hours).padStart(2,'0');
    if(mEl) mEl.textContent = String(mins).padStart(2,'0');
    if(sEl) sEl.textContent = String(secs).padStart(2,'0');
  }
  tick();
  setInterval(tick, 1000);
});

/* ---- Category browser: sidebar tab switching ---- */
document.querySelectorAll('.cat-browser-wrap').forEach(wrap => {
  const sidebarItems = wrap.querySelectorAll('.cb-sidebar-item');
  const panels = wrap.querySelectorAll('.cb-panel');

  sidebarItems.forEach(item => {
    item.addEventListener('click', () => {
      const target = item.getAttribute('data-cb-target');

      sidebarItems.forEach(i => i.classList.remove('active'));
      item.classList.add('active');

      panels.forEach(p => {
        if (p.getAttribute('data-cb-panel') === target) {
          p.classList.add('active');
        } else {
          p.classList.remove('active');
        }
      });
    });
  });
});

/* ---- Mobile nav toggle (basic) ---- */
document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-mobile-nav-toggle]');
  const nav = document.querySelector('.cat-nav');
  if(toggle && nav){
    toggle.addEventListener('click', () => nav.classList.toggle('open'));
  }
});

/* ---- Mobile mega-menu: tap to open (hover doesn't exist on touch) ---- */
(function(){
  function isTouchLayout(){
    return window.matchMedia('(max-width: 900px)').matches;
  }

  const navItems = document.querySelectorAll('.cat-nav .nav-item');

  navItems.forEach(item => {
    const link = item.querySelector('.nav-link');
    const menu = item.querySelector('.mega-menu');
    if (!link || !menu) return;

    link.addEventListener('click', function(e){
      if (!isTouchLayout()) return;      // desktop keeps hover + normal link
      if (item.classList.contains('open')) return;  // second tap follows the link
      e.preventDefault();
      navItems.forEach(i => { if (i !== item) i.classList.remove('open'); });
      item.classList.add('open');
    });
  });

  // Tap anywhere outside closes any open menu
  document.addEventListener('click', function(e){
    if (!isTouchLayout()) return;
    if (e.target.closest('.cat-nav')) return;
    navItems.forEach(i => i.classList.remove('open'));
  });

  // Reset state when rotating / resizing back to desktop
  window.addEventListener('resize', function(){
    if (!isTouchLayout()) navItems.forEach(i => i.classList.remove('open'));
  });
})();

/* ---- Keep active category-browser tab scrolled into view on mobile ---- */
document.querySelectorAll('.cb-sidebar-item').forEach(btn => {
  btn.addEventListener('click', function(){
    if (window.matchMedia('(max-width: 900px)').matches && btn.scrollIntoView) {
      btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  });
});

/* ---- Mobile nav drawer ---- */
(function(){
  const drawer  = document.querySelector('[data-mnav]');
  const overlay = document.querySelector('[data-mnav-overlay]');
  const openBtn = document.querySelector('[data-mnav-open]');
  const closeBtn= document.querySelector('[data-mnav-close]');
  if(!drawer || !overlay || !openBtn) return;

  function open(){
    drawer.classList.add('open');
    overlay.classList.add('open');
    drawer.setAttribute('aria-hidden','false');
    document.body.classList.add('mnav-lock');
  }
  function close(){
    drawer.classList.remove('open');
    overlay.classList.remove('open');
    drawer.setAttribute('aria-hidden','true');
    document.body.classList.remove('mnav-lock');
  }

  openBtn.addEventListener('click', open);
  overlay.addEventListener('click', close);
  if(closeBtn) closeBtn.addEventListener('click', close);

  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape') close();
  });

  // Accordion: only one category open at a time
  drawer.querySelectorAll('[data-mnav-toggle]').forEach(btn => {
    btn.addEventListener('click', function(){
      const item = btn.closest('.mnav-item');
      const wasOpen = item.classList.contains('open');
      drawer.querySelectorAll('.mnav-item').forEach(i => i.classList.remove('open'));
      if(!wasOpen) item.classList.add('open');
    });
  });

  // Close drawer if the viewport grows back to desktop
  window.addEventListener('resize', function(){
    if(!window.matchMedia('(max-width: 900px)').matches) close();
  });
})();

/* ============================================================
   PRODUCT PAGE: gallery, variants, quantity
   ============================================================ */
(function(){
  const form = document.getElementById('pdpForm');

  /* Gallery: switch between images and videos */
  const stageItems = document.querySelectorAll('.pdp-stage-item');
  document.querySelectorAll('[data-media-target]').forEach(btn => {
    btn.addEventListener('click', function(){
      const id = btn.getAttribute('data-media-target');

      stageItems.forEach(item => {
        const on = item.getAttribute('data-media-id') === id;
        item.classList.toggle('active', on);
        if(!on){
          const vid = item.querySelector('video');
          if(vid && !vid.paused) vid.pause();
          const frame = item.querySelector('iframe');
          if(frame) frame.src = frame.src;   // stops embedded playback
        }
      });

      document.querySelectorAll('[data-media-target]').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });

  /* Quantity stepper */
  const qtyInput = document.querySelector('[data-qty-input]');
  const minus = document.querySelector('[data-qty-minus]');
  const plus  = document.querySelector('[data-qty-plus]');
  if(qtyInput){
    if(minus) minus.addEventListener('click', () => {
      const v = parseInt(qtyInput.value, 10) || 1;
      if(v > 1) qtyInput.value = v - 1;
    });
    if(plus) plus.addEventListener('click', () => {
      const v = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = v + 1;
    });
  }

  /* Variant selection */
  const dataEl = document.getElementById('pdpVariants');
  if(!dataEl || !form) return;

  let variants = [];
  try { variants = JSON.parse(dataEl.textContent); } catch(e){ return; }

  const idField   = form.querySelector('[data-pdp-variant-id]');
  const priceEl   = document.querySelector('[data-pdp-price]');
  const compareEl = document.querySelector('[data-pdp-compare]');
  const stockEl   = document.querySelector('[data-pdp-stock]');
  const atcBtn    = document.querySelector('[data-pdp-atc]');

  const stageEl = document.querySelector('[data-money-format]');
  const shopFmt = stageEl ? stageEl.getAttribute('data-money-format') : '${{amount}}';

  function money(cents){
    const v = (cents || 0) / 100;
    const withDec = v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const noDec   = Math.round(v).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return shopFmt
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withDec)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDec)
      .replace(/\{\{\s*amount\s*\}\}/g, withDec);
  }

  function currentSelection(){
    const groups = document.querySelectorAll('.pdp-option');
    const sel = [];
    groups.forEach(g => {
      const active = g.querySelector('.pdp-swatch.active');
      sel.push(active ? active.getAttribute('data-option-value') : null);
    });
    return sel;
  }

  function matchVariant(sel){
    return variants.find(v => sel.every((val, i) => val === null || v.options[i] === val));
  }

  function update(){
    const variant = matchVariant(currentSelection());
    if(!variant) return;

    if(idField) idField.value = variant.id;
    if(priceEl) priceEl.textContent = money(variant.price);

    if(compareEl){
      if(variant.compare_at_price && variant.compare_at_price > variant.price){
        compareEl.textContent = money(variant.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    if(stockEl){
      stockEl.innerHTML = variant.available
        ? '<span class="pdp-dot in"></span> In stock, ready to ship'
        : '<span class="pdp-dot out"></span> Currently out of stock';
    }

    if(atcBtn){
      atcBtn.disabled = !variant.available;
      atcBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    }

    // switch the gallery to this variant's image
    if(variant.featured_media && variant.featured_media.id){
      const target = String(variant.featured_media.id);
      const item = document.querySelector('.pdp-stage-item[data-media-id="' + target + '"]');
      if(item){
        const stage = document.querySelector('.pdp-stage');
        const items = Array.from(document.querySelectorAll('.pdp-stage-item'));
        const idx = items.indexOf(item);

        if(stage && window.matchMedia('(max-width: 1100px)').matches){
          stage.scrollTo({ left: item.offsetLeft - stage.offsetLeft, behavior: 'smooth' });
        } else {
          items.forEach(function(el){
            const on = el === item;
            el.classList.toggle('active', on);
            if(!on){ const v = el.querySelector('video'); if(v && !v.paused) v.pause(); }
          });
        }
        document.querySelectorAll('[data-media-target]').forEach(function(t, n){
          t.classList.toggle('active', n === idx);
        });
        document.querySelectorAll('[data-dot-index]').forEach(function(d, n){
          d.classList.toggle('active', n === idx);
        });
      }
    }

    if(window.history && window.history.replaceState){
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }
  }

  document.querySelectorAll('.pdp-swatch').forEach(btn => {
    btn.addEventListener('click', function(){
      const group = btn.closest('.pdp-option');
      group.querySelectorAll('.pdp-swatch').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      update();
    });
  });
})();

/* ============================================================
   WISHLIST (saved on the shopper's device)
   ============================================================ */
(function(){
  const KEY = 'shopzora_wishlist';

  function read(){
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch(e){ return []; }
  }
  function write(list){
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch(e){}
  }

  function paint(){
    const list = read();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(btn => {
      const on = list.indexOf(btn.getAttribute('data-handle')) !== -1;
      btn.classList.toggle('saved', on);
      const label = btn.querySelector('[data-wishlist-label]');
      if(label) label.textContent = on ? 'Saved to Wishlist' : 'Add to Wishlist';
    });
  }

  document.addEventListener('click', function(e){
    const btn = e.target.closest('[data-wishlist-toggle]');
    if(!btn) return;
    e.preventDefault();
    const handle = btn.getAttribute('data-handle');
    let list = read();
    const i = list.indexOf(handle);
    if(i === -1) list.push(handle); else list.splice(i, 1);
    write(list);
    paint();
  });

  paint();

  /* Wishlist page rendering */
  const grid  = document.querySelector('[data-wishlist-grid]');
  const empty = document.querySelector('[data-wishlist-empty]');
  const clear = document.querySelector('[data-wishlist-clear]');
  if(!grid) return;

  if(clear){
    clear.addEventListener('click', function(){
      write([]);
      render();
    });
  }

  function card(p){
    const price = p.price != null ? (p.price / 100).toFixed(2) : '';
    const compare = p.compare_at_price && p.compare_at_price > p.price
      ? '<span class="prod-mrp">$' + (p.compare_at_price / 100).toFixed(2) + '</span>' : '';
    const img = p.featured_image
      ? '<img src="' + p.featured_image + '" alt="' + p.title + '" loading="lazy">' : '';
    return '' +
      '<a href="/products/' + p.handle + '" class="prod-card">' +
        '<div class="prod-img">' + img +
          '<button class="prod-wish saved" type="button" data-wishlist-toggle data-handle="' + p.handle + '"' +
          '>' +
            '<svg width="15" height="15" viewBox="0 0 24 24" fill="#DB232F" stroke="#DB232F" stroke-width="2">' +
            '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="prod-info">' +
          (p.vendor ? '<div class="prod-brand">' + p.vendor + '</div>' : '') +
          '<div class="prod-name">' + p.title + '</div>' +
          '<div class="prod-price-row"><span class="prod-price">$' + price + '</span>' + compare + '</div>' +
        '</div>' +
      '</a>';
  }

  function render(){
    const list = read();
    grid.innerHTML = '';
    if(list.length === 0){
      if(empty) empty.hidden = false;
      return;
    }
    if(empty) empty.hidden = true;

    Promise.all(list.map(h =>
      fetch('/products/' + h + '.js')
        .then(r => r.ok ? r.json() : null)
        .catch(() => null)
    )).then(items => {
      const found = items.filter(Boolean);
      if(found.length === 0){
        if(empty) empty.hidden = false;
        return;
      }
      grid.innerHTML = found.map(card).join('');
      paint();
    });
  }

  render();
})();

/* ---- Product gallery: swipe sync on touch layouts ---- */
(function(){
  const stage = document.querySelector('.pdp-stage');
  if(!stage) return;

  const items = Array.from(stage.querySelectorAll('.pdp-stage-item'));
  const dots  = Array.from(document.querySelectorAll('[data-dot-index]'));
  const thumbs= Array.from(document.querySelectorAll('[data-media-target]'));

  function isSwipeLayout(){
    return window.matchMedia('(max-width: 1100px)').matches;
  }

  function setActive(i){
    dots.forEach((d, n) => d.classList.toggle('active', n === i));
    thumbs.forEach((t, n) => t.classList.toggle('active', n === i));
    items.forEach((item, n) => {
      if(n === i) return;
      const v = item.querySelector('video');
      if(v && !v.paused) v.pause();
    });
  }

  function scrollTo(i){
    if(!items[i]) return;
    stage.scrollTo({ left: items[i].offsetLeft - stage.offsetLeft, behavior: 'smooth' });
  }

  let ticking = false;
  stage.addEventListener('scroll', function(){
    if(!isSwipeLayout() || ticking) return;
    ticking = true;
    requestAnimationFrame(function(){
      const i = Math.round(stage.scrollLeft / stage.clientWidth);
      setActive(Math.max(0, Math.min(i, items.length - 1)));
      ticking = false;
    });
  });

  dots.forEach((dot, i) => dot.addEventListener('click', () => scrollTo(i)));

  thumbs.forEach((t, i) => t.addEventListener('click', function(){
    if(isSwipeLayout()) scrollTo(i);
  }));
})();

/* ---- Product carousels ---- */
document.querySelectorAll('.section').forEach(function(section){
  const track = section.querySelector('[data-pc-track]');
  if(!track) return;

  const prev = section.querySelector('[data-pc-prev]');
  const next = section.querySelector('[data-pc-next]');
  if(!prev || !next) return;

  function step(){
    const item = track.querySelector('.pc-item');
    if(!item) return track.clientWidth * 0.8;
    const gap = parseInt(getComputedStyle(track).gap, 10) || 18;
    return (item.getBoundingClientRect().width + gap) * 2;
  }

  function sync(){
    const max = track.scrollWidth - track.clientWidth - 2;
    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= max;
  }

  prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
  next.addEventListener('click', () => track.scrollBy({ left:  step(), behavior: 'smooth' }));
  track.addEventListener('scroll', sync);
  window.addEventListener('resize', sync);
  sync();
});

/* ---- Rotating announcement bar ---- */
(function(){
  const bar = document.querySelector('[data-announce]');
  if(!bar) return;
  const msgs = bar.querySelectorAll('.announce-msg');
  if(msgs.length < 2) return;
  let i = 0;
  setInterval(function(){
    msgs[i].classList.remove('active');
    i = (i + 1) % msgs.length;
    msgs[i].classList.add('active');
  }, 4000);
})();

/* ---- Back to top ---- */
(function(){
  const btn = document.querySelector('[data-to-top]');
  if(!btn) return;
  function sync(){ btn.classList.toggle('show', window.scrollY > 600); }
  window.addEventListener('scroll', sync, { passive: true });
  btn.addEventListener('click', function(){
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
  sync();
})();

/* ---- Sticky add to cart (mobile product page) ---- */
(function(){
  const bar  = document.querySelector('[data-pdp-sticky]');
  const form = document.getElementById('pdpForm');
  const atc  = document.querySelector('[data-pdp-atc]');
  if(!bar || !form || !atc) return;

  const btn   = bar.querySelector('[data-pdp-sticky-btn]');
  const price = bar.querySelector('[data-pdp-sticky-price]');
  const mainPrice = document.querySelector('[data-pdp-price]');

  function sync(){
    const r = atc.getBoundingClientRect();
    const passed = r.bottom < 0 || r.top > window.innerHeight;
    bar.classList.toggle('show', passed);
    if(btn){
      btn.disabled = atc.disabled;
      btn.textContent = atc.disabled ? 'Sold Out' : 'Add to Cart';
    }
    if(price && mainPrice) price.textContent = mainPrice.textContent;
  }

  window.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', sync);

  if(btn){
    btn.addEventListener('click', function(){
      if(btn.disabled) return;
      form.submit();
    });
  }

  sync();
})();

/* ---- Cart quantity steppers ---- */
document.querySelectorAll('[data-qty-step]').forEach(function(btn){
  btn.addEventListener('click', function(){
    const wrap  = btn.closest('.cart-qty');
    const input = wrap ? wrap.querySelector('[data-cart-qty]') : null;
    if(!input) return;

    const step = parseInt(btn.getAttribute('data-qty-step'), 10) || 0;
    let next = (parseInt(input.value, 10) || 0) + step;
    if(next < 0) next = 0;
    input.value = next;

    const form = btn.closest('form');
    if(form) form.submit();
  });
});

/* ============================================================
   CART: update quantities without reloading the page
   ============================================================ */
(function(){
  const root = document.querySelector('[data-cart-root]');
  if(!root) return;

  const fmt = root.getAttribute('data-money-format') || '${{amount}}';

  function money(cents){
    const v = (cents || 0) / 100;
    const withDec = v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const noDec   = Math.round(v).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withDec)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDec)
      .replace(/\{\{\s*amount\s*\}\}/g, withDec);
  }

  function setBusy(on){
    root.classList.toggle('cart-busy', on);
  }

  function refresh(cart){
    // line rows
    root.querySelectorAll('[data-line-key]').forEach(row => {
      const key = row.getAttribute('data-line-key');
      const line = cart.items.find(i => i.key === key);

      if(!line){
        row.style.height = row.offsetHeight + 'px';
        row.classList.add('cart-item--going');
        setTimeout(() => row.remove(), 260);
        return;
      }

      const qtyEl = row.querySelector('[data-line-qty]');
      if(qtyEl) qtyEl.textContent = line.quantity;

      const totEl = row.querySelector('[data-line-total]');
      if(totEl) totEl.textContent = money(line.final_line_price);

      row.querySelectorAll('[data-cart-change]').forEach(btn => {
        const q = btn.getAttribute('data-qty');
        if(q === '0') return;                 // remove button stays at 0
        const isMinus = btn.textContent.trim() === '\u2212' || btn.getAttribute('aria-label') === 'Decrease quantity';
        const next = isMinus ? line.quantity - 1 : line.quantity + 1;
        btn.setAttribute('data-qty', next);
        btn.href = '/cart/change?id=' + key + '&quantity=' + next;
      });
    });

    // totals
    const sub = root.querySelector('[data-cart-subtotal]');
    if(sub) sub.textContent = money(cart.total_price);
    const tot = root.querySelector('[data-cart-total]');
    if(tot) tot.textContent = money(cart.total_price);

    const cnt = root.querySelector('[data-cart-count]');
    if(cnt) cnt.textContent = cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's');

    // header basket badge
    const badge = document.querySelector('.cart-count');
    if(badge) badge.textContent = cart.item_count;

    if(cart.item_count === 0){
      window.location.reload();               // show the empty state
    }
  }

  root.addEventListener('click', function(e){
    const btn = e.target.closest('[data-cart-change]');
    if(!btn) return;
    e.preventDefault();
    if(root.classList.contains('cart-busy')) return;

    const key = btn.getAttribute('data-key');
    const qty = parseInt(btn.getAttribute('data-qty'), 10);
    if(isNaN(qty) || qty < 0) return;

    setBusy(true);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(r => r.json())
      .then(cart => { refresh(cart); setBusy(false); })
      .catch(() => { window.location.href = btn.href; });   // fall back to the plain link
  });
})();

/* ---- Policy popup ---- */
(function(){
  const modal   = document.querySelector('[data-pm]');
  const overlay = document.querySelector('[data-pm-overlay]');
  if(!modal || !overlay) return;

  const titleEl = modal.querySelector('[data-pm-title]');
  const docs    = modal.querySelectorAll('[data-pm-doc]');

  function open(id){
    let matched = false;
    docs.forEach(d => {
      const on = d.getAttribute('data-pm-doc') === id;
      d.hidden = !on;
      if(on){
        matched = true;
        if(titleEl) titleEl.textContent = d.getAttribute('data-pm-heading') || '';
      }
    });
    if(!matched) return;

    overlay.hidden = false;
    modal.hidden = false;
    document.body.classList.add('pm-lock');
    requestAnimationFrame(function(){
      overlay.classList.add('open');
      modal.classList.add('open');
    });
    const btn = modal.querySelector('[data-pm-close]');
    if(btn) btn.focus();
  }

  function close(){
    overlay.classList.remove('open');
    modal.classList.remove('open');
    document.body.classList.remove('pm-lock');
    setTimeout(function(){
      overlay.hidden = true;
      modal.hidden = true;
    }, 300);
  }

  document.addEventListener('click', function(e){
    const opener = e.target.closest('[data-pm-open]');
    if(opener){
      e.preventDefault();
      open(opener.getAttribute('data-pm-open'));
      return;
    }
    if(e.target.closest('[data-pm-close]')) { close(); return; }
    if(e.target === overlay) close();
  });

  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && !modal.hidden) close();
  });
})();

/* ============================================================
   PRODUCT IMAGE ZOOM — lens over the photo, magnified panel beside
   ============================================================ */
(function(){
  const stage = document.querySelector('[data-zoom-stage]');
  const lens  = document.querySelector('[data-zoom-lens]');
  const panel = document.querySelector('[data-zoom-panel]');
  if(!stage || !lens || !panel) return;

  const ZOOM = 2.4;

  function activeImg(){
    const item = stage.querySelector('.pdp-stage-item.active') || stage.querySelector('.pdp-stage-item');
    return item ? item.querySelector('img') : null;
  }

  function usable(){
    return window.matchMedia('(min-width: 1201px)').matches
        && window.matchMedia('(hover: hover)').matches;
  }

  stage.addEventListener('mouseenter', function(){
    const img = activeImg();
    if(!usable() || !img) return;

    const src = img.currentSrc || img.src;
    panel.style.backgroundImage = 'url("' + src + '")';
    panel.style.backgroundSize =
      (stage.clientWidth * ZOOM) + 'px ' + (stage.clientHeight * ZOOM) + 'px';
    stage.classList.add('zooming');
  });

  stage.addEventListener('mouseleave', function(){
    stage.classList.remove('zooming');
  });

  stage.addEventListener('mousemove', function(e){
    if(!stage.classList.contains('zooming')) return;

    const r = stage.getBoundingClientRect();
    const lw = lens.offsetWidth, lh = lens.offsetHeight;

    let x = e.clientX - r.left - lw / 2;
    let y = e.clientY - r.top  - lh / 2;
    x = Math.max(0, Math.min(x, r.width  - lw));
    y = Math.max(0, Math.min(y, r.height - lh));

    lens.style.left = x + 'px';
    lens.style.top  = y + 'px';

    panel.style.backgroundPosition = '-' + (x * ZOOM) + 'px -' + (y * ZOOM) + 'px';
  });
})();

/* ---- Country / currency picker submits on change ---- */
document.querySelectorAll('[data-loc-select]').forEach(function(sel){
  sel.addEventListener('change', function(){
    const form = sel.closest('form');
    if(form) form.submit();
  });
});
